import { parseMatchAliases } from "@/lib/opsDealTypes/dealTypeMatch";

export function DealTypesMatchAliasesField(props: {
  value: string;
  onChange: (next: string) => void;
}) {
  const count = parseMatchAliases({ match_tags: props.value }).length;
  return (
    <label className="block text-sm text-gray-700 dark:text-zinc-300">
      Match tags
      <textarea
        className="mt-1 block w-full rounded border border-gray-300 px-2 py-1.5 font-mono text-xs dark:border-zinc-600 dark:bg-zinc-900"
        rows={2}
        value={props.value}
        onChange={(e) => props.onChange(e.target.value)}
        placeholder={"one per line, e.g.\ninventory\noff-lot"}
      />
      <span className="mt-1 block text-xs text-gray-500 dark:text-zinc-400">
        Product types and sale types both carry tags. Incoming feeds are matched against these plus the
        type key and name. Put both inventory/off-lot and custom/new-build on <strong>one</strong> product
        so they stamp fulfillment instead of cloning a second product. Leave leftover rows in place until
        rematch is proven. Host map: off-lot → inventory, new-build → custom.{" "}
        {count ? `${count} tag(s).` : "Empty means only the key and display name can auto-match."}
      </span>
    </label>
  );
}
